export enum CampaignLogStatus {
  SENT = "SENT",
  CLICKED = "CLICKED",
  FAILED = "FAILED",
  DELIVERED = "DELIVERED",
  READ = "READ",
}
